import React from 'react';
import BaseModal from 'components/UI/BaseModal';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';

function Confirm({
  open,
  title,
  message,
  onCancel,
  cancelText,
  onConfirm,
  confirmText,
  modalProps,
  contentProps,
}) {
  return (
    <BaseModal
      size="sm"
      open={open}
      title={title}
      hasEnterButton
      hasCancelButton
      onEnter={onConfirm}
      onCancel={onCancel}
      enableCloseButton={false}
      enterButtonLabel={confirmText}
      cancelButtonLabel={cancelText}
      aria-labelledby="confirm-title"
      {...modalProps}
    >
      <Box mt={1.5} data-cy="confirm" {...contentProps}>
        <Typography id="modal-title" variant="body2" gutterBottom>
          {message}
        </Typography>
      </Box>
    </BaseModal>
  );
}

Confirm.propTypes = {
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  message: PropTypes.string,
  onConfirm: PropTypes.func,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  title: PropTypes.string.isRequired,
};

Confirm.defaultProps = {
  open: false,
  title: '',
  message: '',
  cancelText: '',
  confirmText: '',
  onCancel: () => {},
  onConfirm: () => {},
};

export default Confirm;
